export default __webpack_public_path__ + "4cd5a957c34ba2f94bc197b92ce82d55.svg";